import { render, staticRenderFns } from "./NothingFound.vue?vue&type=template&id=51b2f4db"
import script from "./NothingFound.vue?vue&type=script&lang=js"
export * from "./NothingFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports